var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    !_vm.isSupportApartments
      ? _c("div", [
          _c("span", [_vm._v(_vm._s(_vm.$t("Instructions.Question")))]),
          _vm._v(" "),
          _c("p", { staticClass: "question" }, [
            _vm._v(_vm._s(_vm.$t("AidApplication.BasicInfo.OperationName")))
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("span", [_vm._v(_vm._s(_vm.$t("Instructions.Question")))]),
    _vm._v(" "),
    _c("p", { staticClass: "question" }, [
      _vm._v(_vm._s(_vm.$t("AidApplication.BasicInfo.Investment.Purpose")))
    ]),
    _vm._v(" "),
    _c("p", [
      _vm._v(
        _vm._s(
          _vm.$t("AidApplication.BasicInfo.Investment.Purpose_Instructions")
        )
      )
    ]),
    _vm._v(" "),
    _c("span", [_vm._v(_vm._s(_vm.$t("Instructions.Question")))]),
    _vm._v(" "),
    _c("p", { staticClass: "question" }, [
      _vm._v(_vm._s(_vm.$t(_vm.startTimeLabel)))
    ]),
    _vm._v(" "),
    _c("p", [_vm._v(_vm._s(_vm.$t(_vm.startTimeInstructions)))]),
    _vm._v(" "),
    _c("span", [_vm._v(_vm._s(_vm.$t("Instructions.Question")))]),
    _vm._v(" "),
    _c("p", { staticClass: "question" }, [
      _vm._v(_vm._s(_vm.$t(_vm.endTimeLabel)))
    ]),
    _vm._v(" "),
    _c("p", [_vm._v(_vm._s(_vm.$t(_vm.endTimeInstructions)))]),
    _vm._v(" "),
    _vm.isICT
      ? _c("div", [
          _c("span", [_vm._v(_vm._s(_vm.$t("Instructions.Question")))]),
          _vm._v(" "),
          _c("p", { staticClass: "question" }, [
            _vm._v(_vm._s(_vm.$t("AidApplication.BasicInfo.Location.Title")))
          ]),
          _vm._v(" "),
          _c("ul", [
            _c("li", [
              _c("b", [
                _vm._v(
                  _vm._s(
                    _vm.$t(
                      "AidApplication.BasicInfo.Location.Selection.Municipality"
                    )
                  )
                )
              ]),
              _vm._v(" "),
              _c("div", [
                _vm._v(
                  _vm._s(
                    _vm.$t(
                      "AidApplication.BasicInfo.Municipalities.Title_Instructions"
                    )
                  )
                )
              ])
            ]),
            _vm._v(" "),
            _c("li", [
              _c("b", [
                _vm._v(
                  _vm._s(
                    _vm.$t("AidApplication.BasicInfo.Location.Selection.Region")
                  )
                )
              ]),
              _vm._v(" "),
              _c("div", [
                _vm._v(
                  _vm._s(
                    _vm.$t(
                      "AidApplication.BasicInfo.Regions.Title_Instructions"
                    )
                  )
                )
              ])
            ]),
            _vm._v(" "),
            _c("li", [
              _c("b", [
                _vm._v(
                  _vm._s(
                    _vm.$t("AidApplication.BasicInfo.Location.Selection.Abroad")
                  )
                )
              ]),
              _vm._v(" "),
              _c("div", [
                _vm._v(
                  _vm._s(
                    _vm.$t(
                      "AidApplication.BasicInfo.Location.Selection.Abroad_Instructions"
                    )
                  )
                )
              ])
            ]),
            _vm._v(" "),
            _c("li", [
              _c("b", [
                _vm._v(
                  _vm._s(
                    _vm.$t(
                      "AidApplication.BasicInfo.Location.Selection.Nationwide"
                    )
                  )
                )
              ]),
              _vm._v(" "),
              _c("div", [
                _vm._v(
                  _vm._s(
                    _vm.$t(
                      "AidApplication.BasicInfo.Location.Selection.Nationwide_Instructions"
                    )
                  )
                )
              ])
            ])
          ]),
          _vm._v(" "),
          _c("span", [_vm._v(_vm._s(_vm.$t("Instructions.Question")))]),
          _vm._v(" "),
          _c("p", { staticClass: "question" }, [
            _vm._v(_vm._s(_vm.$t("AidApplication.BasicInfo.Channel.Title")))
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              _vm._s(
                _vm.$t("AidApplication.BasicInfo.Channel.Title_Instructions")
              )
            )
          ]),
          _vm._v(" "),
          _c("ul", [
            _c("li", [
              _vm._v(
                _vm._s(
                  _vm.$t("AidApplication.BasicInfo.Channel.Selection.Phone")
                )
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                _vm._s(
                  _vm.$t("AidApplication.BasicInfo.Channel.Selection.Online")
                )
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                _vm._s(
                  _vm.$t("AidApplication.BasicInfo.Channel.Selection.Chat")
                )
              )
            ])
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.isPremises
      ? _c("div", [
          _c("span", [_vm._v(_vm._s(_vm.$t("Instructions.Question")))]),
          _vm._v(" "),
          _c("p", { staticClass: "question" }, [
            _vm._v(
              _vm._s(
                _vm.$t("AidApplication.BasicInfo.Investment.TargetInfo.Title")
              )
            )
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              _vm._s(
                _vm.$t(
                  "AidApplication.BasicInfo.Investment.TargetInfo.Title_Instructions"
                )
              )
            )
          ]),
          _vm._v(" "),
          _c("ul", [
            _c("li", [
              _vm._v(
                _vm._s(
                  _vm.$t(
                    "AidApplication.BasicInfo.Investment.TargetInfo.BusinessId"
                  )
                )
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                _vm._s(
                  _vm.$t(
                    "AidApplication.BasicInfo.Investment.TargetInfo.RealEstateId"
                  )
                )
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                _vm._s(
                  _vm.$t(
                    "AidApplication.BasicInfo.Investment.TargetInfo.ConstructionYear"
                  )
                )
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                _vm._s(
                  _vm.$t("AidApplication.BasicInfo.Investment.TargetInfo.IsOwn")
                )
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "ml-3" }, [
            _c(
              "label",
              {
                attrs: {
                  "aria-label": _vm.$t("Instructions.FurtherDescription")
                }
              },
              [_vm._v(_vm._s(_vm.$t("Instructions.FurtherDescription")))]
            ),
            _vm._v(" "),
            _c("p", { staticClass: "question" }, [
              _vm._v(
                _vm._s(
                  _vm.$t(
                    "AidApplication.BasicInfo.Investment.TargetInfo.OwnershipExplanation"
                  )
                )
              )
            ])
          ]),
          _vm._v(" "),
          _c("span", [_vm._v(_vm._s(_vm.$t("Instructions.Question")))]),
          _vm._v(" "),
          _c("p", { staticClass: "question" }, [
            _vm._v(
              _vm._s(
                _vm.$t("AidApplication.BasicInfo.Investment.Address.Title")
              )
            )
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              _vm._s(
                _vm.$t(
                  "AidApplication.BasicInfo.Investment.Address.Title_Instructions"
                )
              )
            )
          ]),
          _vm._v(" "),
          _c("ul", [
            _c("li", [
              _vm._v(
                _vm._s(
                  _vm.$t("AidApplication.BasicInfo.Investment.Address.Postal")
                )
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                _vm._s(
                  _vm.$t(
                    "AidApplication.BasicInfo.Investment.Address.PostalCode"
                  )
                )
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                _vm._s(
                  _vm.$t("AidApplication.BasicInfo.Investment.Address.City")
                )
              )
            ])
          ])
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }